import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { getFormattedTicketPrice } from '../../../utils/tickets/get-formatted-ticket-price';
import { OrderCartContextInstance } from '../types/context';
const b = bemClassBuilder('v-order-cart-ticket');
export const OrderCartTicket = observer(props => {
    const i18n = useI18n();
    const { displayText } = useContext(OrderCartContextInstance);
    const { orderTicket, ticketType, quantity } = props;
    const details = getFormattedTicketDetails(displayText.ticketDetails, ticketType, quantity, i18n);
    const price = getFormattedTicketPrice(orderTicket, i18n, quantity);
    return (_jsxs("li", Object.assign({ className: b.block() }, { children: [_jsx("span", Object.assign({ className: b.element('description') }, { children: details })), _jsx("span", Object.assign({ className: b.element('price') }, { children: price }))] })));
});
OrderCartTicket.displayName = 'OrderCartTicket';
const getFormattedTicketDetails = (template, ticketType, quantity, i18n) => {
    const description = i18n.translatable(ticketType.description);
    return i18n.template(template, { quantity, description });
};
